<template>
    <v-container>
      <v-card>
        <v-card-title>
          Box WhatsApp Group
          <v-icon right>mdi-whatsapp</v-icon>
        </v-card-title>
        <v-card-text><strong>
            A box might have a corresponding WhatsApp group. This group is used to communicate messages relevant for the members of the group. Like, planned box opening, box opened, etc.
            Due to a lot of members (potentially), messages should be kept to an absolute minimum. </strong>
        </v-card-text>
        <v-card-text>
            Note: This will probably be the future prefered method to announce box openings. In stead of SMS. <kbd>See Notification Service.</kbd> 
        </v-card-text>
        <v-card-subtitle>
          
          <p><strong>How to join the group:</strong></p>
          <p><i>Do it from your mobile device.</i></p>
          <p><i>(Log In.)</i></p>
          <p>1: Menu: Boxes.</p>
          <p>2: Tap the dropdown menu in the upper right corner of the box.</p>
          <p>3: Select "WhatsApp Group"</p>
          <p>4: You are then invited to the group in WhatsApp</p>
        </v-card-subtitle>
      </v-card>
    </v-container>
  </template>
  
  <script>
  export default {
      data () {
          return {
            //   HelpLsb1: require('@/assets/HelpLsb1.png'),
            //   HelpLsb2: require('@/assets/HelpLsb2.png')
          }
      }
  }
  </script>